/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-12-05 13:52:43
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-03-27 13:53:57
 */
import { copyDeep } from 'common/js/util.js'
/**
 * 获取 表格/表单 头部描述字段名
 * @param {*} allList 总描述字段表
 * @param {*} needList 需要获取字段的字段列表
 * @param {*} tabType 表单内容展示方式：view/search/edit 预览查看/搜索/默认(编辑)
 */
export function getTitleDes(allList, needList, tabType) {
  let result = []
  if (!needList || !Array.isArray(needList)) {
    return
  }
  console.log('needList', needList)
  needList.forEach(needItem => {
    if (!needItem) {
      return
    }
    // 在总描述字段表中找到的item
    // console.log(needItem)
    let item = searchItem(allList, needItem)
    console.log('item', item)
    // 只是预览查看时候, 显示文本(非输入框)
    if (tabType == 'view' && (!item.type || item.type != 'title')) {
      // 富文本时不可编辑
      if (item.type == 'editText') {
        item.editTextDisable = true
        // 非富文本时打上标签
      } else {
        item.type = 'view'
      }
    } else {
      if (item.type == 'editText') {
        item.editTextDisable = false
      }
    }
    result.push(item)
  })
  console.log('result', result)
  return result
}

// 总描述字段表中 查找 需要获取字段的字段列表
export function searchItem(all, needItem) {
  let item = all.find(e2 => {
    if (typeof needItem == 'string') {
      return needItem == e2.prop
    } else if (typeof needItem == 'object') {
      return needItem.prop == e2.prop
    }
  })
  item = copyDeep(item)
  // 若‘获取字段’本身是一个对象，以‘获取对象’的配置为准
  if (typeof needItem == 'object') {
    item = { ...item, ...needItem }
  }
  return item || null
}

export function timeGet(data) {
  data = data.map((e) => {
    e = e + ''
    if (e.length == 1) {
      return '0'+e
    } else {
      return e
    }
  })
  if (data) {
    var time = data[0] + '-' + data[1] + '-' + data[2] + ' ' + data[3] + ':' + data[4] + ':' + data[5]
  }
  return time
}



// WEBPACK FOOTER //
// ./src/common/js/formDes/util.js